/*ORDER_ACCEPTED
ORDER_DECLINED
ORDER_OFFERS
ORDER_COUNTER_OFFERS
ORDER_PAYMENT_CONFIRM
ORDER_MARK_AS_COMPLETE
ORDER_NOT_COMPLETE
ORDER_COMPLETE
ORDER_ACCEPTED_AND_CLOSED
ORDER_CANCELLED*/

const ORDER_PENDING = 1;
const ORDER_PROCESSING = 2;
const ORDER_SHIPPED = 3;
const ORDER_DENIED = 4;
const ORDER_CANCELLED = 5;
const ORDER_FAILED = 6;
const ORDER_REFUNDED = 7;
const ORDER_REVERSED = 8;
const ORDER_VOIDED = 9;
const ORDER_EXPIRED = 10;
const ORDER_ACCEPTED = 11;
const ORDER_ACCEPTED_AND_CLOSED = 12;
const ORDER_DECLINED = 13;
const ORDER_MARK_AS_COMPLETE = 14;
const ORDER_NOT_COMPLETE = 15;
const ORDER_DISPUTE = 16;
const ORDER_DISPUTE_PROCESSING = 17;
const ORDER_DISPUTE_INVESTIGATION = 18;
const ORDER_DISPUTE_CANCELED = 19;
const ORDER_DISPUTE_RESOLVED = 20;
const ORDER_COMPLETE = 21;
const ORDER_OFFERS = 23;
const ORDER_COUNTER_OFFERS = 24;
const ORDER_PAYMENT_CONFIRM = 25;
const STATUS_PAYMENT_TRANSFER = 26;


const status = (item) => {
    let statusTitle = '';
    let cls = '';
    switch(item.status) {
        case ORDER_PENDING:
            statusTitle = 'Pending';
            cls = 'primary';
            break;
        case ORDER_ACCEPTED:
            statusTitle = 'Approved';
            cls = 'primary';
            break;
        case ORDER_DECLINED:
            statusTitle = 'Declined';
            cls = 'danger';
            break;
        case ORDER_OFFERS:
            statusTitle = 'Offers';
            cls = 'secondary';
            break;
        case ORDER_COUNTER_OFFERS:
            statusTitle = 'Counter Offers';
            cls = 'secondary';
            break;
        case ORDER_PAYMENT_CONFIRM:
            statusTitle = 'Confirm';
            cls = 'warning';
            break;
        case ORDER_MARK_AS_COMPLETE:
            statusTitle = 'Mark as Completed';
            cls = 'primary';
            break;
        case ORDER_NOT_COMPLETE:
            statusTitle = 'Not Complete';
            cls = 'warning';
            break;
        case ORDER_DISPUTE:
            statusTitle = 'Disputed';
            cls = 'danger';
            break;
        case ORDER_COMPLETE:
            statusTitle = 'Complete';
            cls = 'success';
            break;
        case STATUS_PAYMENT_TRANSFER:
            statusTitle = 'Complete';
            cls = 'success';
            break;
        case ORDER_ACCEPTED_AND_CLOSED:
            statusTitle = 'Accept and Closed';
            cls = 'success';
            break;
        case ORDER_CANCELLED:
            statusTitle = 'Cancelled';
            cls = 'danger';
            break;
        default:;
    }
    return {title: statusTitle, cls: cls};
}

export const orderStatus = {
    status,
    ORDER_PENDING,
    ORDER_PROCESSING,
    ORDER_SHIPPED,
    ORDER_DENIED,
    ORDER_CANCELLED,
    ORDER_FAILED,
    ORDER_REFUNDED,
    ORDER_REVERSED,
    ORDER_VOIDED,
    ORDER_EXPIRED,
    ORDER_ACCEPTED,
    ORDER_ACCEPTED_AND_CLOSED,
    ORDER_DECLINED,
    ORDER_MARK_AS_COMPLETE,
    ORDER_NOT_COMPLETE,
    ORDER_DISPUTE,
    ORDER_DISPUTE_PROCESSING,
    ORDER_DISPUTE_INVESTIGATION,
    ORDER_DISPUTE_CANCELED,
    ORDER_DISPUTE_RESOLVED,
    ORDER_COMPLETE,
    ORDER_OFFERS,
    ORDER_COUNTER_OFFERS,
    ORDER_PAYMENT_CONFIRM,
    STATUS_PAYMENT_TRANSFER,
};